import { r, s } from '@/theme/tokens';
import type { SxProps, Theme } from '@mui/material/styles';

type SxObject = Exclude<SxProps<Theme>, readonly unknown[]>;

export const overlayScrollbarSx: SxObject = {
  scrollbarWidth: 'thin',
  scrollbarColor: (theme) => `${theme.app.colors.border} transparent`,
  '&::-webkit-scrollbar': {
    width: s('sm'),
    height: s('sm'),
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-track': {
    backgroundColor: 'transparent',
    borderRadius: r('pill'),
  },
  '&::-webkit-scrollbar-corner': {
    backgroundColor: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: (theme) => theme.app.colors.border,
    backgroundClip: 'content-box',
    border: `${s('xxs')} solid transparent`,
    borderRadius: r('pill'),
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: (theme) => theme.palette.text.secondary,
  },
};
